const hotels = {
  back: "Atrás", // translated
  rooms: "Habitaciones", // translated
  viewPictures: "Ver fotos", // translated
  showMore: "mostrar más", // translated
  bookingInformation: "Información de la reserva", // translated
  cancellationPolicy: "Política de cancelación", // translated
  from: "Desde", // translated
  to: "para", // translated
  cancellationIs: "la cancelación es", // translated
  free: "gratis", // translated
  chargeableWithFeeOf: "a cargo de una tarifa de", // translated
  prebook: "Reservar de antemano", // translated
  guests: "Huéspedes", // translated
  payment: "Pago", // translated
  byClicking: "Haciendo click", // translated
  next: "próximo", // translated
  youAreAgreeingToOur: "usted está de acuerdo con nuestro", // translated
  termsAndConditions: "Términos y condiciones", // translated
  previous: "Anterior", // translated
  cancel: "Cancelar", // translated
  mealPlan: "Régimen de comidas", // translated
  roomType: "Tipo de habitación", // translated
  description: "Descripción", // translated
  readLess: "Leer menos", // translated
  readMore: "Lee mas", // translated
  facilities: "Instalaciones", // translated
  viewLess: "Ver menos", // translated
  viewMore: "Ver más", // translated
  less: "menos", // translated
  more: "más", // translated
  notAvailable_short: "N / A", // translated
  backToHotelList: "Volver a la lista de hoteles", // translated
  viewOnMap: "Ver en el mapa", // translated
  sleeps: "duerme", // translated
  adults: "Adultos", // translated
  yearsOld: "años", // translated
  type: "Tipo", // translated
  bedding: "Lecho", // translated
  selectRoom: "Seleccionar habitación", // translated
  city: "Ciudad", // translated
  checkIn: "Registrarse", // translated
  checkOut: "Verificar", // translated
  date: "Fecha", // translated
  persons: "personas", // translated
  stillOnTrialQuestionToUpgrade: "¡Ups! Parece que todavía estás en una membresía de prueba. Necesitas ser un miembro confirmado para hacer reservas. ¿Desea actualizar ahora?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "¡Ups! Parece que aún no estás suscrito. Necesitas ser un miembro confirmado para hacer reservas. ¿Desea actualizar ahora?", // translated
  completeProfile: "Primero complete su perfil de usuario", // translated
  upgrade: "Mejora", // translated
  close: "Cerrar", // translated
  viewDetails: "Ver detalles", // translated
  name: "Nombre", // translated
  rating: "Clasificación", // translated
  budget: "Presupuesto", // translated
  orderBy: "ordenar por", // translated
  priceLowestFirst: "Precio: el más bajo primero)", // translated
  priceHighestFirst: "Precio: más caros primero)", // translated
  ratingLowestFirst: "Calificación (la más baja primero)", // translated
  ratingHighestFirst: "Calificación (la más alta primero)", // translated
  starRatingAndPrice: "Valoración por estrellas y precio", // translated
  select: "Seleccione", // translated
  reset: "Reiniciar", // translated
  apply: "Aplicar", // translated
  filterBy: "Filtrado por", // translated
  myProfile: "Mi perfil", // translated
  login: "Acceso", // translated
  roomOnly: "Solo Habitación", // translated
  bedAndBreakfast: "Cama y Desayuno", // translated
  halfBoard: "Madia pizarra", // translated
  fullBoard: "Pensión completa", // translated
  allInclusive: "Todo incluido", // translated
  filter: "Filtrar", // translated
  mapView: "Vista del mapa", // translated
  results: "resultados", // translated
  listView: "Vista de la lista", // translated
  newSearch: "Nueva búsqueda", // translated
  editSearch: "Editar búsqueda", // translated
  all: "Todos", // translated
  multiple: "Múltiple", // translated
  editProfile: "Editar perfil", // translated
  backToHotelsList: "Volver a la Lista de Hoteles", // translated
  roomName: "Nombre de la habitación", // translated
  mealType: "Tipo de comida", // translated
  freeCancellation: "Cancelación gratis", // translated
  yes: "Sí", // translated
  no: "No", // translated
  filters: "filtros", // translated
  cancellationNonRefundable: "La cancelación no es reembolsable", // translated
  off: "Apagado", // translated
  performNewSearch: "Realizar una nueva búsqueda", // translated
  selectRooms: "Seleccionar Habitaciones", // translated
  dates: "fechas", // translated
  hotels: "Hoteles", // translated
  biggestSavingsFirst: "Los mayores ahorros primero", // translated
  any: "Cualquier", // translated
  accommodation: "Alojamiento", // translated
  hotelRating: "Calificación del hotel", // translated
  hotel: "Hotel", // translated
};


export default hotels;
